import DatePicker from "react-date-picker";
import { Card, Line } from "ktm-ui";

const FlexDatesCard = ({ handleDateChange, LaunchDate, ReminderDate, LastDayReminder, SelectionDeadline }) => {
  return (
    <Card>
      <Line>
        <div className="date-picker-container">
          <div className="RT-Section-Header">
            <div className="RT-Section-Header-Title">Launch Date</div>
          </div>
          <DatePicker
            onChange={(e) => {
              handleDateChange(e, "LaunchDate");
            }}
            value={new Date(LaunchDate)}
            format={"y-MM-dd"}
            minDate={new Date()}
            clearIcon={null}
          />
        </div>
        <div className="date-picker-container">
          <div className="RT-Section-Header">
            <div className="RT-Section-Header-Title">Reminder Date</div>
          </div>
          <DatePicker
            onChange={(e) => {
              handleDateChange(e, "ReminderDate");
            }}
            value={new Date(ReminderDate)}
            format={"y-MM-dd"}
            minDate={new Date()}
            clearIcon={null}
          />
        </div>
      </Line>
      <Line>
        <div className="date-picker-container">
          <div className="RT-Section-Header">
            <div className="RT-Section-Header-Title">Last Day Reminder</div>
          </div>
          <DatePicker
            onChange={(e) => {
              handleDateChange(e, "LastDayReminder");
            }}
            value={new Date(LastDayReminder)}
            format={"y-MM-dd"}
            minDate={new Date()}
            clearIcon={null}
          />
        </div>
        <div className="date-picker-container">
          <div className="RT-Section-Header">
            <div className="RT-Section-Header-Title">Selection Deadline</div>
          </div>
          <DatePicker
            onChange={(e) => {
              handleDateChange(e, "SelectionDeadline");
            }}
            value={new Date(SelectionDeadline)}
            format={"y-MM-dd"}
            minDate={new Date()}
            clearIcon={null}
          />
        </div>
      </Line>
    </Card>
  );
};

export default FlexDatesCard;
